import React from 'react';
import DekorInput from '../commons/DekorInput.jsx'
import GriffInput from '../commons/GriffInput.jsx'
import NumberInput from '../commons/NumberInput.jsx'
import RadioGroup from '../commons/RadioGroup.jsx'
import Select from '../commons/Select.jsx'
import Helper from "../../../model/Helper";
import SidebarFrame from "./SidebarFrame";

export default class SchubladenSettings extends SidebarFrame {

    renderTitle() {
        return I18N("Schublade");
    }

    state = {
        nutzhoehe: this.nutzhoehe(this.schublade.faecherHoehe),
        products: APP.findProductsByType('Schubladenbox')
    }

    get schublade() {
        return this.props.model.vsData;
    }

    getSidebarParent() {
        return "einbauten";
    }

    faecherChanged(faecherAnzahl,faecherHoehe) {
        const calc = this.schublade.calcFaecherHoehe(faecherAnzahl, faecherHoehe);
        if (calc.anzahl != faecherAnzahl) {
            this.setState({
                message: I18N("Ungültige Höhe.")
            });
        } else {
            this.setState({
                message: Math.abs(calc.hoehe - this.schublade.faecherHoehe) > 0.1 ? I18N('dialogSchubladenboxKorrigiert', Helper.round(calc.hoehe)) /*'Die Fachhöhe wurde auf ' + hoehe + ' korrgiert.'*/ : '',
                nutzhoehe: this.nutzhoehe(calc.hoehe)
            });
            APP.model.tryCompile(() => this.schublade.setFaecher(calc.anzahl, calc.hoehe));
        }
    }

    nutzhoehe(hoehe) {
        return Helper.round(hoehe - APP.settings.getFloat('schublade_nutzhoehe_offset'))
    }

    cm(value) {
        return Helper.formatNum(value);
    }

    renderBody() {
        if (this.schublade.element==null) {
            return;
        }

        const arrangement = APP.arrangement;
        const maxFaecher = Math.floor(this.schublade.maxFaecher)
        const options = [...Array(maxFaecher - 1).keys()].map(value => ({value: value + 1, label: value + 1}));
        const types = this.state.products.map(product => ({
            value: product.Artikelnummer,
            label: product.Anzeigename,
        }));

        const hasDekorwahl = this.schublade.hasFronts || APP.settings.getBool('SchubladeInnenliegend_mit_dekorwahl',false);

        return (
            <div>
                <fieldset>
                    <legend>{I18N("Maße")}</legend>
                    <table>
                        <tbody>
                        <tr>
                            <td>{I18N("Breite")}:</td>
                            <td>{this.cm(this.schublade.size.x)} cm</td>
                        </tr>
                        <tr>
                            <td>{I18N("Tiefe")}:</td>
                            <td>{this.cm(this.schublade.size.z)} cm</td>
                        </tr>
                        <tr>
                            <td>{I18N("Nutzhöhe")}:</td>
                            <td>{this.cm(this.state.nutzhoehe)} cm</td>
                        </tr>
                        <tr>
                            <td colSpan="2">{this.state.message}</td>
                        </tr>
                        </tbody>
                    </table>
                </fieldset>

                <Select value={this.schublade.faecherAnzahl} options={options}
                        onChange={value => this.faecherChanged(value, this.schublade.faecherHoehe)} label={I18N("Anzahl Fächer")}/>

                {APP.settings.getMaxValue('schublade_hoehe')-APP.settings.getMinValue('schublade_hoehe')>0.1 && (
                    <NumberInput value={this.schublade.faecherHoehe} onCommit={value => this.faecherChanged(this.schublade.faecherAnzahl, value)}
                                 label={I18N("dialogSchubladenboxHeight")} unit={"cm"}/>
                )}

                {/*{hasDekorwahl && (<DekorInput value={APP.getMaterialForVsData(this.schublade)} appear={true}*/}
                                              {/*dekore={APP.getMaterialsForVsData(this.schublade)}*/}
                                              {/*setValue={value=>APP.setMaterialForVsData(this.schublade,value)}*/}
                                              {/*label={I18N("Welches Dekor wünschen Sie?")}/>)}*/}


                {/*{this.schublade.hasFronts && (*/}
                    {/*<GriffInput value={APP.arrangement.griffArtikelnummer}*/}
                                {/*setValue={APP.model.tryWrap(this, value => APP.arrangement.griffArtikelnummer = value)}*/}
                                {/*label={I18N("Welche Griffe wünschen Sie?")}/>*/}
                {/*)}*/}

            </div>
        )
    }
}